export enum TrackingHoursStateEnum {
    WaitingForApproval = 0,
    Approved = 1,
    Template = 2
}

